import {Subject, BehaviorSubject} from 'rxjs';
import {skipUntil, switchMap, take, filter, map} from 'rxjs/operators';
import {mc} from '@/core';
import {defaultFiatCurrencyByHost} from '@/helper/localized-site';
import {userApi} from '@/api/user';
import {wwData$} from '@/streams/worker-data';
import {isCtSubUser, isStrategySubUser} from '@/streams/utils';
import {browser$} from '@/streams/browser';
import {fiatCurrency$} from './fiat-currency';

/**
 * 加载用户数据 如果参数为true，则调用 forceRefreshUserInfo()
 */
export const loadUserInfo$ = new Subject<void>();
export const userInfo$ = new BehaviorSubject(createInitUserInfo());

export const subUserInfos$ = userInfo$.pipe(map((info) => info.subUsers || []));
export const botUserIds$ = subUserInfos$.pipe(
  map((users) => users.filter(isStrategySubUser)),
  map((users) => users.map((u) => u.userId))
);
export const ctUserIds$ = subUserInfos$.pipe(
  map((users) => users.filter(isCtSubUser)),
  map((users) => users.map((u) => u.userId))
);

export const loadUserTag$ = new Subject();
export const userTags$ = new BehaviorSubject({});

export const loadMemberLevel$ = new Subject();
export const userMemberLevel$ = new BehaviorSubject(0);

export const commonGray$ = new BehaviorSubject(initGray());

commonGray$
  .pipe(
    filter(({isInit}) => !isInit),
    map(({riskEngineMode}) => !!riskEngineMode)
  )
  .subscribe((data) => {
    wwData$.send({type: 'risk-engine-mode', data});
  });

loadMemberLevel$
  .pipe(
    switchMap(() => userApi.getUserMemberLevel()),
    take(1)
  )
  .subscribe((o) => {
    if (o.data) {
      userMemberLevel$.next(o.data.memberLevel);
    }
  });

loadUserInfo$.pipe(switchMap(() => userApi.getUsersSelf())).subscribe(({data, error}) => {
  if (data) {
    userInfo$.next(data);
    fiatCurrency$.next(data.currency || defaultFiatCurrencyByHost);
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
});

userInfo$
  .pipe(
    skipUntil(browser$),
    filter(({userId}) => userId > 0)
  )
  .subscribe((o) => getCommonGray());

loadUserTag$.pipe(switchMap(getTag), filter(Boolean)).subscribe((o) => userTags$.next(o));

async function getTag() {
  const {data, error} = await userApi.getTag();
  if (error) {
    mc.send('toast', 'error', error);
  }
  return data;
}

export async function getBaseKycCheck() {
  const {data, error} = await userApi.getBaseKycCheck();
  if (data) {
    return data;
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
  return {};
}

async function getCommonGray() {
  const {data, error} = await userApi.getGray();
  if (data) {
    commonGray$.next({...data, isInit: false});
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
}

export const queryLocalIp$ = new Subject();
export const localIp$ = new BehaviorSubject({countryCode: null});

queryLocalIp$
  .pipe(
    skipUntil(browser$),
    switchMap(() => loadLocalIp())
  )
  .subscribe((x) => localIp$.next(x));

async function loadLocalIp() {
  const {data, error} = await userApi.loadLocalIp();
  if (data) {
    return data;
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
  return {countryCode: null};
}

export function createInitUserInfo() {
  return {
    // 钱包地址
    address: '',
    avatar: '7ec0d398bea20b43.png',
    clientCnt: 0,
    email: '',
    lang: 'en',
    memberLevelCode: 0,
    nickName: '',
    parentEmail: '',
    parentId: -1,
    previousUserId: 0,
    referralCode: '',
    referralType: -1,
    roles: [],
    subUsers: [],
    totp: -1,
    userId: 0,
    lastLoginTime: 0,
    isMain: true,
    isSub: false,
    currency: '',
    vipLevel: 0,
    pdSet: 0,
    createTime: 0,
    uta: {
      spot: 0,
    },
    lendingAccount: {
      status: 0,
    },
  };
}

function initGray() {
  return {
    isInit: true,
    strategyUserGray: false,
    spotStrategyGrid: false,
    riskEngineMode: false, // 浮盈加仓
  };
}
